import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=848b7bde&scoped=true"
import script from "./Rating.vue?vue&type=script&lang=js"
export * from "./Rating.vue?vue&type=script&lang=js"
import style0 from "./Rating.vue?vue&type=style&index=0&id=848b7bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848b7bde",
  null
  
)

export default component.exports